import { createSlice } from "@reduxjs/toolkit";
import { REPORT_PAGE_SIZE } from "../../common/constants";

export const initialState = {
  error: {},
  events: {},
  messages: {
  },
  report: {
    dateRange: null, //  [new Date(), new Date().setMonth(new Date().getMonth() - 1)]
    selectedMultiFloorPlan: null,
    selectedMultiMonitorType: null,
    selectedMultiMonitorStatus: null,
    selectedMultiEventHandling: null,
    selectedCompanyID: null,
    eventIDs:[],
    events: {},
    changes: {},
    totalEvents: 0,
    pageNumber: "1",
    pageSize: REPORT_PAGE_SIZE,
    lastUpdated: new Date().getTime(),
    isLoading: false,
    selectedCompanyFloorPlans: []
  },
  connection: {
    dateRange: null, //  [new Date(), new Date().setMonth(new Date().getMonth() - 1)]
    selectedDeviceID: null,
    selectedCompanyID: null,
    connectionLog:[],
    pageNumber: "1",
    pageSize: REPORT_PAGE_SIZE,
    totalConnectionLogs : 0,
    lastUpdated: new Date().getTime(),
    isLoading: false,
  },
  company: [],
  device: {}
};

const developerSlice = createSlice({
  name: 'Developer',
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
    },
    getEventSuccess(state, action) {
      state.events = action.payload.events;
    },
    getEventMessageSuccess(state, action) {
      state.messages[action.payload.eventID] = action.payload.result;
    },    
    getEventsReportSuccess(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          ...action.payload.data,
          isLoading: false
        }
      }
    },
    setReportEventSelectedCompanyID(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          selectedCompanyID: action.payload,
          pageNumber: "1",
        }
      }
    },
    setReportEventDateRange(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          dateRange: [...action.payload],
          pageNumber: "1",
        }
      }
    },
    setReportEventSelectedMultiFloorPlan(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          selectedMultiFloorPlan: [...action.payload],
          pageNumber: "1",
        }
      }
    },
    setReportEventSelectedMultiMonitorType(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          selectedMultiMonitorType: [...action.payload],
          pageNumber: "1",
        }
      }
    },
    setReportEventSelectedMultiMonitorStatus(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          selectedMultiMonitorStatus: [...action.payload],
          pageNumber: "1",
        }
      }
    },
    setReportEventSelectedEventHandling(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          selectedMultiEventHandling: [...action.payload],
          pageNumber: "1",
        }
      }
    },
    setReportPage(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          pageNumber: action.payload,
        }
      }
    },
    setIsReportLoading(state, action) {
      console.log(action);
      return {
        ...state,
        report: {
          ...state.report,
          isLoading: action.payload
        }
      }
    },
    getAllCompaniesSuccess(state, action) {
      state.company = action.payload.data;
    },
    getFloorPlansByCompanyIDSuccess(state, action) {
      state.report.selectedCompanyFloorPlans = action.payload.data;
    },
    setConnectionLogSelectedCompanyID(state, action) {
      console.log(action);
      return {  
        ...state,
        connection: {
          ...state.connection,
          selectedCompanyID: action.payload,  
          pageNumber: "1",
          selectedDeviceID: null,
          connectionLog:[],
        }
      }
    },
    setConnectionLogDeviceID(state, action) {
      console.log(action);
      return {  
        ...state,
        connection: {
          ...state.connection,
          selectedDeviceID: action.payload,  
          pageNumber: "1",
        }
      }
    },
    setConnectionLogDateRange(state, action) {
      console.log(action);
      return {
        ...state,
        connection: {
          ...state.connection,
          dateRange: [...action.payload],  
          pageNumber: "1",
        }
      }
    },
    setConnectionLogPage(state, action) {
      console.log(action);
      return {  
        ...state,
        connection: {
          ...state.connection,  
          pageNumber: action.payload,
        }
      }
    },
    setIsConnectionLogLoading(state, action) {
      console.log(action);
      return {
        ...state,
        connection: {
          ...state.connection,
          isLoading: action.payload
        }
      }
    },
    getConnectionLogByDeviceIDSuccess(state, action) {
      console.log(action);
      return {  
        ...state,
        connection: {
          ...state.connection,
          connectionLog: action.payload.data.logs,
          totalConnectionLogs: action.payload.data.pagination.total,
          pageNumber: action.payload.data.pagination.page,
          pageSize: action.payload.data.pagination.pageSize,
          isLoading: false
        }
      }
    },
    getDeviceIDByCompanyIDSuccess(state, action) {
      let companyID = action.payload.companyID;
      return {
        ...state,
        device: {
          ...state.device,
          [companyID]: action.payload.data,
        }
      }
    },
    resetState: () => initialState
  }
});

export const {
  apiError,
  setIsReportLoading,
  setReportEventDateRange,
  setReportEventSelectedCompanyID,
  setReportEventSelectedEventHandling,
  setReportEventSelectedMultiFloorPlan,
  setReportEventSelectedMultiMonitorType,
  setReportEventSelectedMultiMonitorStatus,
  setReportPage,
  getEventSuccess,
  getAllCompaniesSuccess,
  resetState,
  getFloorPlansByCompanyIDSuccess,
  getEventMessageSuccess,
  createEventMessageSuccess,
  getEventsReportSuccess,
  getEventsReportListSuccess,
  setConnectionLogSelectedCompanyID,
  setConnectionLogDeviceID,
  setConnectionLogDateRange,
  setConnectionLogPage,
  setIsConnectionLogLoading,
  getConnectionLogByDeviceIDSuccess,
  getDeviceIDByCompanyIDSuccess
} = developerSlice.actions

export default developerSlice.reducer;